import { render, staticRenderFns } from "./bulkAddPostGres.vue?vue&type=template&id=e5def1d8&scoped=true"
import script from "./bulkAddPostGres.vue?vue&type=script&lang=js"
export * from "./bulkAddPostGres.vue?vue&type=script&lang=js"
import style0 from "./bulkAddPostGres.vue?vue&type=style&index=0&id=e5def1d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5def1d8",
  null
  
)

export default component.exports